module.exports = __webpack_public_path__ + "media/target_area_icon/dept_backoffice-d88c981f.png";